import React from 'react';
import { Radar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend
} from 'chart.js';

ChartJS.register(
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend
);

const FinancialHealthRadarChart: React.FC = () => {
  // BUG-UI-040 FIX: Renamed "Cash on Hand" to "Liquid Reserves" for consistency
  const data = {
    labels: [
      'Debt to Income',
      'Liquid Reserves',
      'Spending',
      'Savings',
      'Debt',
      'Payment History'
    ],
    datasets: [
      {
        label: 'Financial Health Metrics',
        data: [85, 78, 82, 75, 80, 88],
        borderColor: '#8b5cf6',
        backgroundColor: 'rgba(139, 92, 246, 0.2)',
        borderWidth: 2,
        pointBackgroundColor: '#8b5cf6',
        pointBorderColor: 'white',
        pointBorderWidth: 2,
        pointRadius: 4
      }
    ]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false
      },
      tooltip: {
        backgroundColor: 'rgba(0, 0, 0, 0.85)',
        titleColor: '#ffffff',
        bodyColor: '#ffffff',
        borderColor: 'rgba(0, 0, 0, 0.1)',
        borderWidth: 1,
        cornerRadius: 8,
        padding: 12,
        callbacks: {
          label: function(context: any) {
            return `${context.label}: ${context.parsed.r}`;
          }
        }
      }
    },
    scales: {
      r: {
        angleLines: {
          color: 'rgba(148, 163, 184, 0.2)'
        },
        grid: {
          color: 'rgba(148, 163, 184, 0.2)'
        },
        pointLabels: {
          color: '#64748b',
          font: {
            size: 11
          }
        },
        ticks: {
          color: '#94a3b8',
          font: {
            size: 10
          },
          backdropColor: 'transparent'
        },
        min: 0,
        max: 100
      }
    }
  };

  return (
    <div className="h-80">
      <Radar data={data} options={options} />
    </div>
  );
};

export default FinancialHealthRadarChart;